import * as Types from '../types';
import { Environment } from '../../../config';
import request from '../../../utils/request';
import { LanguagesEnum } from 'constants/languages';

export interface ICity {
  id: number;
  label: string;
  countryid: number;
}

interface ICitiesOutput extends Types.ResponseOutput {
  data: Array<ICity>;
}

export const fetchAllCities = async (
  language: LanguagesEnum
): Promise<ICitiesOutput> => {
  const { data }: any = await request(
    'get',
    `${Environment.API_BASE_URL}/api/city/list/${language}`
  );

  let _data: ICity[] = data.data;
  let output: Types.ResponseOutput = {
    message: data.message,
    data: _data,
    status: data.status,
  };
  return output;
};
